<template>
  <search-variables
      :variable-item-component="variableComponent"
      :selected-variables="subpopulationVariables"
      title-text="Select Variable(s) for Subpopulation"
      :available-toggle="false"
      @variableClick="variableClick">
  </search-variables>
</template>

<script>

  import { markRaw } from "vue";
  import { mapActions, mapState } from 'pinia';
  import { useApplicationConfigStore } from "App/stores/applicationConfig";
  import { useSelectionStore } from "App/stores/selection";
  import SearchVariables from "App/components/SearchVariables";
  import SelectSubpopulationVariableItem from 'App/components/SelectSubpopulationVariableItem';

  export default {
    data() {
      return {
        variableComponent: markRaw(SelectSubpopulationVariableItem)
      };
    },

    computed: {
      ...mapState(useSelectionStore, [
        "subpopulationVariables"
      ])
    },

    methods: {
      ...mapActions(useApplicationConfigStore, ["addAlert"]),
      ...mapActions(useSelectionStore, [
        "subpopulationForVariable",
        "isVariableSubpopulation",
        "removeSubpopulation"
      ]),

      variableClick(variable) {
        if (this.isVariableSubpopulation(variable)) {
          this.removeSubpopulation(this.subpopulationForVariable(variable));
        } else {
          this.$router.push({name: 'edit_subpopulation', params: { variableId: variable.id }});
        }
      }
    },

    components: {
      SearchVariables
    }
  }

</script>

<style lang="scss" scoped>
</style>